import { SvgProps } from "components/icons/types";

export const FileEtd = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11559_3180)">
        <mask
          id="mask0_11559_3180"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="17"
        >
          <path d="M16 0H0V16H16V0Z" fill="white" />
          <path
            d="M12.25 16.55C14.6248 16.55 16.55 14.6248 16.55 12.25C16.55 9.87513 14.6248 7.94995 12.25 7.94995C9.87513 7.94995 7.94995 9.87513 7.94995 12.25C7.94995 14.6248 9.87513 16.55 12.25 16.55Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_11559_3180)">
          <path
            d="M5.5 8H9.25V9H5.5V8ZM5.5 11H8V10H5.5V11Z"
            fill="currentColor"
          />
          <path
            d="M13 5.793V14H3V3.5C3 3.10218 3.15804 2.72064 3.43934 2.43934C3.72064 2.15804 4.10218 2 4.5 2H9.20712L13 5.793ZM9.5 5.5H11.2931L9.5 3.707V5.5ZM12 13V6.5H8.5V3H4.5C4.36739 3 4.24021 3.05268 4.14645 3.14645C4.05268 3.24021 4 3.36739 4 3.5V13H12Z"
            fill="currentColor"
          />
        </g>
        <path
          d="M12.25 15.25C13.9069 15.25 15.25 13.9069 15.25 12.25C15.25 10.5931 13.9069 9.25 12.25 9.25C10.5931 9.25 9.25 10.5931 9.25 12.25C9.25 13.9069 10.5931 15.25 12.25 15.25Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 10.75V12.25L11.1 12.95"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11559_3180">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
